<template>
  <div id="fee_detail">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            檢視規約
          </div>
        </div>
        <div class="right">
          <el-button
            plain
            @click="$router.push({name:'RulesEdit', query: { statuteId: ruleData.id }})"
          >
            編輯
          </el-button>
          <el-button
            type="danger"
            plain
            @click="delRule"
          >
            刪除
          </el-button>
        </div>
      </div>
      <div class="blockWrap">
        <el-form
          ref="feeDetailEdit"
          class="list"
          status-icon
          label-position="left"
        >
          <el-form-item label="標題">
            <template>{{ ruleData.title }}</template>
          </el-form-item>
          <el-form-item label="規約類型">
            <template>{{ ruleData.typeName }}</template>
          </el-form-item>
          <el-form-item
            label="建立日期"
            class=""
          >
            <template>{{ ruleData.createdTime }}</template>
          </el-form-item>
          <el-form-item
            label="更新日期"
            class=""
          >
            <template>{{ ruleData.updatedTime }}</template>
          </el-form-item>
          <el-form-item label="附加檔案">
            <template>
              <div class="file-wrap">
                <a
                  v-for="(file,index) in ruleData.files"
                  :key="index"
                  class="file"
                  :href="file.expiringUrl || file.url"
                  target="_blank"
                  rel="noopener"
                >
                  <span>{{ file.fileName }}</span>
                </a>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottomControl">
        <el-button @click="$router.push({name:'Rules'})">
          返回規約列表
        </el-button>
      </div>
    </div>
    <lightbox
      id="mylightbox"
      ref="lightbox"
      :images="images"
    />
  </div>
</template>
<script>
export default {
  data () {
    return {
      ruleData: {
        id: '',
        title: '',
        typeName: '',
        createdTime: '',
        updatedTime: '',
        files: []
      },
      images: [],
      TypeList: []
    }
  },
  mounted () {
    this.authorization = this.$getCookie('comLoginToken').replace('token=', '')
    this.getRuleData()
  },
  methods: {
    // 取得規約詳細
    getRuleData () {
      axios(`${process.env.VUE_APP_MAPI_URL}/Statute/Info`, {
        method: 'GET',
        headers: { Authorization: this.authorization },
        params: { Id: this.$route.params.id }
      }).then(res => {
        const resData = res.data.Data
        console.log(resData)
        resData.CreateTime = resData.CreateTime.replace(/\//g, '-').slice(0, 10)
        if (resData.LastUpdateTime) {
          resData.LastUpdateTime = resData.LastUpdateTime.replace(/\//g, '-').slice(0, -3)
        } else {
          resData.LastUpdateTime = '-'
        }
        this.ruleData = {
          id: resData.StatuteId,
          title: resData.Title,
          typeName: resData.TypeName,
          createdTime: resData.CreateTime,
          updatedTime: resData.LastUpdateTime,
          files: []
        }
        resData.Attached.forEach(item => {
          this.ruleData.files.push({
            type: 'file',
            file: '',
            url: item.url,
            expiringUrl: item.expiringUrl,
            fileName: item.fileName
          })
        })
        console.log(this.ruleData)
      }).catch(err => {
        console.log(err)
      })
    },
    showLightbox (imageName) {
      this.$refs.lightbox.show(imageName)
    },
    // 刪除規約
    delRule () {
      // let vm = this;
      this.$confirm('規約刪除後將無法復原，確認是否刪除？', '', {
        confirmButtonText: '確定',
        cancelButtonText: '取消'
      }).then(() => {
        console.log('aaa')
        axios(`${process.env.VUE_APP_MAPI_URL}/Statute/Delete`, {
          method: 'DElETE',
          data: { Id: this.ruleData.id },
          headers: { Authorization: this.authorization }
        }).then(res => {
          this.$message({
            type: 'success',
            message: '刪除規約成功'
          })
          this.$store.commit('recordRulesHeight', null)
          this.$router.push({ name: 'Rules' })
        }).catch(err => {
          console.log(err)
          this.$message({
            message: '刪除規約失敗',
            type: 'error'
          })
        })
      }).catch(() => {
        console.log('bbb')
        this.$message({
          message: '取消刪除',
          type: 'info'
        })
      })
    },
    giveTypeName (typeNo, list) {
      let haveName = false
      for (const item of list) {
        // eslint-disable-next-line eqeqeq
        if (item.Id == typeNo) {
          haveName = true
          return item.Name
        } else {
          haveName = false
        }
      }
      // eslint-disable-next-line eqeqeq
      if (haveName == false) {
        return '類型已被刪除'
      }
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_detail
  padding: 50px 0
  ::v-deep .el-dialog
    +basicDialog
    p
      line-height: 25px
  .main
    min-width: 1140px
    max-width: 1140px
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        color: $mainFontColor
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
  ::v-deep .el-form.list
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    .el-form-item
      display: flex
      align-items: flex-start
      width: 100%
      box-sizing: border-box
      +basicForm
      &.Interval
        width: 50%
      &.half
        width: 50%
      &__label
        font-weight: bold
        flex-basis: 105px
        vertical-align: top
        text-align: right
      &__content
        flex: 1
        // max-width: 400px
        .el-select,.el-date-editor
          width: 100%
        .file-wrap
          display: flex
          flex-wrap: wrap
          .file
            width: 150px
            height: 150px
            border: 1px solid #ccc
            color: #666
            border-radius: 4px
            cursor: pointer
            margin: 10px
            display: flex
            justify-content: center
            align-items: center
            flex-direction: column
            position: relative
            overflow: hidden
            &:hover
              color: #333
              border: 1px solid #aaa
              box-shadow: inset 0 1px 2px -1px rgba(0,0,0,.075), 0 0 8px rgba(120,120,120,.5)
              transition: .4s
              .optionBtn-wrap
                bottom: 0
            i
              font-size: 60px
            span
              font-size: 17px
              font-weight: 700
              width: 100%
              white-space: nowrap
              text-overflow: ellipsis
              overflow: hidden
              text-align: center
              margin-top: 10px
            .bg-img
              height: 100%
              width: 100%
              background-position: center
              background-size: cover
      &.Detail
        > .el-form-item__content
          line-height: initial
  .blockWrap
    text-align: left
    display: inline-flex
    flex-wrap: wrap
    width: 100%
    margin-bottom: 30px
    padding: 0 70px 0 30px
    box-sizing: border-box
    +NewsStatusTag
  .bottomControl
    text-align: center
    border-top: solid 1px $borderDark1
    padding: 30px 0 0
</style>
